import type { Edl } from './edl.js';
import type { Word } from './types.js';

/** Use with a V1/virtual EDL and words on the same clock. An excluded take may
 * overlap a retained word in ASR timestamps; time containment alone is ambiguous.
 */
export function isExcludedSpeechWord(edl: Edl, word: Word): boolean {
  return edl.editorial?.excluded_words?.some(w => w.text === word.text
    && Math.abs(w.src_in - word.start) < 0.000001
    && Math.abs(w.src_out - word.end) < 0.000001) ?? false;
}

export function retainedSpeechWords(edl: Edl, words: Word[]): Word[] {
  return words.filter(w => !isExcludedSpeechWord(edl, w));
}
